import TypeButton from './typeButton.view';

export default TypeButton;
